import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { UserProfile } from './UserProfile';

import { Loader } from '../Elements/Loader';

import { useLocalStorage } from '../../CustomHooks/useLocalStorage';
import { DashboardUserInfoRow } from '../DashboardUserInfoRow';
import { setUserInfo, getUserById, getUserResidencyInfo } from '../../actions/';
import { TOKEN } from '../../constants';

import './index.css';

export const ProfilePage = () => {
  const { user, jwt, residencyReducer, loading, csrfToken } = useSelector(
    ({ userReducer: { user, jwt, loading, csrfToken }, residencyReducer }) => ({
      user,
      jwt,
      residencyReducer,
      loading,
      csrfToken,
    }),
  );

  const [value] = useLocalStorage(TOKEN);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!value && !jwt) {
      navigate('/login');
      return;
    }
    const raw = localStorage.getItem(TOKEN);
    if (raw && !user) {
      const payload = JSON.parse(atob(raw.split('.')[1]));
      dispatch((d) => setUserInfo(d, payload));
    }
  }, [value, jwt, dispatch, navigate]);

  useEffect(() => {
    if (user?.id && !user.hasOwnProperty('firstname')) {
      dispatch(getUserById({ id: user.id, token: value }));
    }
    if (user?.id) {
      dispatch(getUserResidencyInfo({ id: user.id, tokenValue: value }));
    }
  }, [value, user?.id]);

  if (!value) {
    navigate('/login');
  }

  //so when there is a
  if (!user) {
    return <Loader />;
  }
  return (
    <div>
      <div className="dashboard-user-info-wrapper">
        <DashboardUserInfoRow
          setZipCode={() => {}}
          setUsState={() => {}}
          user={user}
          tokenValue={value}
        />
      </div>
      <UserProfile
        user={user}
        userAddress={residencyReducer}
        token={value}
        loading={loading}
        csrfToken={csrfToken}
      />
    </div>
  );
};
